<div class="container">
  <p>&nbsp;</p>
	<div class="col-md-12">
		<div class="col-md-6 col-md-offset-4">
  <div class="notify successbox">
    <h1>Success!</h1>
    <h3><i class="fa fa-check-circle-o fa-2x"></i></h3>
    <p>An email with password reset instructions has been sent to the email address you provided</p>
    <p>&nbsp;</p>
  </div>
</div>
  </div>
</div>
